import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api', // Set your API base URL
});

// Add a request interceptor to include the token in headers
axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log(error.response);
    return Promise.reject(error);
  }
);

export default axiosInstance;